import React, { useContext } from 'react';
import { Step } from '../models/Step';
import { useNavigate } from 'react-router-dom';
import { thousandNumberSeperator } from '../utils/format';
import { ApplicationFormStateContext } from '../state/applicationFormState';

const ProductIndicator: React.FunctionComponent = () => {
  const [state] = useContext(ApplicationFormStateContext);
  const doNotShownIndicator = [Step.Amount, Step.PeriodOfRepayment];
  const navigate = useNavigate();

  const handelAmountClick = () => {
    navigate('/');
  };

  const handelProductClick = () => {
    navigate(`/produkt/${state.amount}`);
  };

  return (
    <>
      { !doNotShownIndicator.includes(state.step) && state.amount && state.periodOfRepaymentOption && (
        <div className="-mx-2 sm:-mx-5 -mt-7 bg-white rounded-t pt-4">
        <div className="w-full">
          <div className="w-1/3 inline-block text-center cursor-pointer" onClick={handelAmountClick} title="Ændre lånebeløb">
            <div className="text-xs uppercase text-regal-darkblue">Lånebeløb</div>
            <div className="text-xs sm:text-xl font-bold text-regal-darkestblue">{thousandNumberSeperator(state.amount)} kr.</div>
          </div>
          <div className="w-1/3 inline-block text-center">&nbsp;</div>
          <div className="w-1/3 inline-block text-center cursor-pointer" onClick={handelProductClick} title="Ændre afdragsperiode">
            <div className="text-xs uppercase text-regal-darkblue">
              <span className="inline">Løbetid</span>
            </div>
            <div className="text-xs sm:text-xl font-bold text-regal-darkestblue">{state.periodOfRepaymentOption} mdr.</div>
          </div>
        </div>
        </div>
      )}
    </>
  );
};

export default ProductIndicator;
